import { Component } from '@angular/core';

@Component({
  selector: 'app-no-result',
  imports: [],
  templateUrl: './no-result.component.html',
  styleUrl: './no-result.component.scss',
})
export class NoResultComponent {

}
